(function(){
  function init(){
    var root=document.getElementById('dmpb');
    if(!root)return;
    var dataEl=root.querySelector('[data-dmpb-json]');
    if(!dataEl)return;
    var DATA;
    try{DATA=JSON.parse(dataEl.textContent);}catch(e){return;}
    var CATS=[
      {k:'case',n:'Chassis',ic:'case'},
      {k:'cpu',n:'Processor',ic:'cpu'},
      {k:'cooler',n:'CPU Cooler',ic:'cooler'},
      {k:'motherboard',n:'Motherboard',ic:'mobo'},
      {k:'gpu',n:'Graphics Card',ic:'gpu'},
      {k:'ram',n:'Memory',ic:'ram'},
      {k:'storage',n:'Storage',ic:'ssd'},
      {k:'psu',n:'Power Supply',ic:'psu'}
    ];
    var RANK={'Mini-ITX':1,'Micro-ATX':2,'ATX':3,'E-ATX':4};
    var HARD={case:1,motherboard:1,ram:1};
    var TIERS=[{id:'apprentice',n:'Apprentice',frac:0},{id:'knight',n:'Knight',frac:0.4},{id:'master',n:'Master',frac:0.72},{id:'dragon',n:'Dragon',frac:1}];
    var TIER_SLUGS={entry:'Entry',mid:'Mid',high:'High',extreme:'Extreme'};
    var ICONS={
      case:`<rect x='4' y='3' width='13' height='18' rx='1'/><line x1='8' y1='7' x2='13' y2='7'/><circle cx='10.5' cy='15' r='2'/>`,
      cpu:`<rect x='6' y='6' width='12' height='12' rx='1'/><rect x='9.5' y='9.5' width='5' height='5'/><line x1='9' y1='3' x2='9' y2='6'/><line x1='15' y1='3' x2='15' y2='6'/><line x1='9' y1='18' x2='9' y2='21'/><line x1='15' y1='18' x2='15' y2='21'/><line x1='3' y1='9' x2='6' y2='9'/><line x1='3' y1='15' x2='6' y2='15'/><line x1='18' y1='9' x2='21' y2='9'/><line x1='18' y1='15' x2='21' y2='15'/>`,
      cooler:`<rect x='4' y='4' width='16' height='16' rx='1'/><circle cx='12' cy='12' r='4'/><line x1='12' y1='4' x2='12' y2='8'/><line x1='12' y1='16' x2='12' y2='20'/>`,
      mobo:`<rect x='3' y='3' width='18' height='18' rx='1'/><rect x='6' y='6' width='5' height='5'/><line x1='14' y1='6' x2='18' y2='6'/><line x1='14' y1='9' x2='18' y2='9'/><line x1='6' y1='14' x2='6' y2='18'/><line x1='9' y1='14' x2='9' y2='18'/>`,
      gpu:`<rect x='2' y='7' width='20' height='11' rx='1'/><circle cx='8' cy='12.5' r='2.5'/><circle cx='15' cy='12.5' r='2.5'/><line x1='2' y1='18' x2='2' y2='21'/>`,
      ram:`<rect x='2' y='7' width='20' height='9' rx='1'/><line x1='6' y1='16' x2='6' y2='19'/><line x1='10' y1='16' x2='10' y2='19'/><line x1='14' y1='16' x2='14' y2='19'/><line x1='18' y1='16' x2='18' y2='19'/>`,
      ssd:`<rect x='4' y='4' width='16' height='16' rx='1'/><line x1='8' y1='9' x2='16' y2='9'/><line x1='8' y1='13' x2='13' y2='13'/>`,
      psu:`<rect x='3' y='5' width='18' height='14' rx='1'/><circle cx='9' cy='12' r='3'/><line x1='15' y1='10' x2='18' y2='10'/><line x1='15' y1='14' x2='18' y2='14'/>`,
      check:`<polyline points='20 6 9 17 4 12'/>`,
      alert:`<path d='M12 3 2 20h20L12 3z'/><line x1='12' y1='10' x2='12' y2='14'/><line x1='12' y1='17' x2='12' y2='17'/>`,
      shield:`<path d='M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z'/>`,
      chev:`<polyline points='6 9 12 15 18 9'/>`,
      expand:`<polyline points='15 3 21 3 21 9'/><polyline points='9 21 3 21 3 15'/><line x1='21' y1='3' x2='14' y2='10'/><line x1='3' y1='21' x2='10' y2='14'/>`
    };
    function svg(name,size){var s=size||18;return `<svg viewBox='0 0 24 24' width='${s}' height='${s}' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'>${ICONS[name]||''}</svg>`;}
    var sel={},anchor=null,preset='apprentice',dirty=false,reveal={},detailsOpen=false,active='case',lastImg=null,editId=null,editKeys=null,TIER=null;
    function $(s){return root.querySelector(s);}
    function allList(k){return DATA[k]||[];}
    function list(k){
      var all=DATA[k]||[];
      if(!TIER)return all;
      var f=all.filter(function(o){return o.tier&&o.tier.indexOf(TIER)>=0;});
      return f.length?f:all;
    }
    function num(v){if(v===null||v===undefined||v==='')return null;var n=Number(v);return isNaN(n)?null:n;}
    function money(c){var n=Number(c)/100;return 'AED '+n.toLocaleString('en-US',{maximumFractionDigits:0});}
    function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/'/g,'&#39;');}
    function getOpt(k,id){var a=allList(k);for(var i=0;i<a.length;i++){if(String(a[i].id)===String(id))return a[i];}return null;}
    function cheapest(a){if(!a||!a.length)return null;var m=a[0];for(var i=1;i<a.length;i++){if(a[i].price<m.price)m=a[i];}return m;}
    function where(a,f){var r=[];for(var i=0;i<a.length;i++){if(f(a[i]))r.push(a[i]);}return r;}
    function cheapestWhere(a,f,full){
      var w=where(a,f);
      if(w.length)return cheapest(w);
      if(full){var w2=where(full,f);if(w2.length)return cheapest(w2);}
      return null;
    }
    function byPrice(a){return a.slice().sort(function(x,y){return x.price-y.price;});}
    function pickAt(a,frac){if(!a||!a.length)return null;var s=byPrice(a);var i=Math.round(frac*(s.length-1));if(i<0)i=0;if(i>s.length-1)i=s.length-1;return s[i];}
    function r50(x){return Math.ceil(x/50)*50;}
    function truthy(v){return v===true||v==='true'||v===1||v==='1';}
    function caseAccepts(c,bf){var cf=c.form_factor;if(!cf||!bf)return true;return (RANK[cf]||0)>=(RANK[bf]||0);}
    function gpuFits(g,c){if(!g)return true;var gl=num(g.length),cm=num(c.max_gpu);if(gl&&cm)return cm>=gl;return true;}
    function coolerFits(cl,c){if(!cl)return true;if(cl.cooler_type==='Air'){var ch=num(cl.height),cc=num(c.max_cooler);if(ch&&cc)return cc>=ch;}return true;}
    function cpuHasBoard(cpu){var all=allList('motherboard');for(var i=0;i<all.length;i++){if(all[i].socket===cpu.socket)return true;}return false;}
    function hardOk(k,o){
      var mb=getOpt('motherboard',sel.motherboard);
      if(k==='motherboard'){var cpu=getOpt('cpu',sel.cpu);return !cpu||o.socket===cpu.socket;}
      if(k==='ram')return !mb||o.ram_type===mb.ram_type;
      if(k==='case')return !mb||caseAccepts(o,mb.form_factor);
      return true;
    }
    function split(k){
      var opts=list(k);
      if(k==='cpu'){ return {ok: opts.filter(cpuHasBoard), bad: []}; }
      if(!HARD[k])return {ok:opts.slice(),bad:[]};
      if(k==='case'&&k===anchor)return {ok:opts.slice(),bad:[]};
      var ok=[],bad=[];
      for(var i=0;i<opts.length;i++){(hardOk(k,opts[i])?ok:bad).push(opts[i]);}
      if(k==='motherboard'||k==='ram')return {ok:ok,bad:[]};
      return {ok:ok,bad:bad};
    }
    function badReason(k,o){
      var mb=getOpt('motherboard',sel.motherboard);
      if(k==='case'&&mb&&!caseAccepts(o,mb.form_factor))return 'Too small for board';
      return 'Incompatible';
    }
    function conflicts(){
      var out=[],cpu=getOpt('cpu',sel.cpu),mb=getOpt('motherboard',sel.motherboard),ram=getOpt('ram',sel.ram),cs=getOpt('case',sel.case);
      if(cpu&&mb&&cpu.socket!==mb.socket)out.push({keys:['motherboard'],msg:'Motherboard socket does not match the selected processor \u2014 pick another board.'});
      if(mb&&ram&&mb.ram_type!==ram.ram_type)out.push({keys:['ram'],msg:'This memory is '+ram.ram_type+' but the motherboard needs '+mb.ram_type+'.'});
      if(mb&&cs&&!caseAccepts(cs,mb.form_factor))out.push({keys:['case'],msg:'A '+mb.form_factor+' board does not fit this '+(cs.form_factor||'')+' case.'});
      return out;
    }
    function estLoad(){var cpu=getOpt('cpu',sel.cpu),gpu=getOpt('gpu',sel.gpu),l=75;if(cpu)l+=num(cpu.power)||0;if(gpu)l+=num(gpu.power)||0;return l;}
    function rec(){return r50(estLoad()*1.5);}
    function dimIssues(){
      var out=[],gpu=getOpt('gpu',sel.gpu),cs=getOpt('case',sel.case),cl=getOpt('cooler',sel.cooler),psu=getOpt('psu',sel.psu);
      if(gpu&&cs){var gl=num(gpu.length),cm=num(cs.max_gpu);if(gl&&cm&&gl>cm)out.push({keys:['gpu','case'],level:'error',msg:'This graphics card is '+gl+'mm long but the case fits up to '+cm+'mm.'});}
      if(cl&&cs&&cl.cooler_type==='Air'){var ch=num(cl.height),cc=num(cs.max_cooler);if(ch&&cc&&ch>cc)out.push({keys:['cooler','case'],level:'error',msg:'This air cooler is '+ch+'mm tall but the case fits up to '+cc+'mm.'});}
      var w=psu?num(psu.wattage):null,load=estLoad();
      if(w){if(w<load)out.push({keys:['psu'],level:'error',msg:'This power supply ('+w+'W) is below the estimated draw of about '+load+'W.'});else if(w<rec())out.push({keys:['psu'],level:'warning',msg:'This power supply ('+w+'W) works but is tight \u2014 about '+rec()+'W is recommended.'});}
      return out;
    }
    function total(){var t=0;for(var i=0;i<CATS.length;i++){var o=getOpt(CATS[i].k,sel[CATS[i].k]);if(o)t+=Number(o.price);}return t;}
    function dimErrCount(){var d=dimIssues(),n=0;for(var i=0;i<d.length;i++){if(d[i].level==='error')n++;}return n;}
    function blocked(){return conflicts().length>0||dimErrCount()>0;}
    function computePreset(frac){
      var cpu=pickAt(list('cpu').filter(cpuHasBoard),frac)||cheapest(list('cpu').filter(cpuHasBoard))||cheapest(list('cpu'));
      var mb=cheapestWhere(list('motherboard'),function(m){return cpu?m.socket===cpu.socket:true;},allList('motherboard'));
      var ram=cheapestWhere(list('ram'),function(r){return mb?r.ram_type===mb.ram_type:true;},allList('ram'));
      var gpu=pickAt(list('gpu'),frac)||cheapest(list('gpu'));
      var st=cheapest(list('storage'));
      var cl=cheapest(list('cooler'));
      var cs=cheapestWhere(list('case'),function(c){return (mb?caseAccepts(c,mb.form_factor):true)&&gpuFits(gpu,c)&&coolerFits(cl,c);},allList('case'));
      var load=75+(cpu?num(cpu.power)||0:0)+(gpu?num(gpu.power)||0:0),need=r50(load*1.5);
      var psu=cheapestWhere(list('psu'),function(p){return (num(p.wattage)||0)>=need;},allList('psu'));
      if(!psu){var ss=byPrice(list('psu'));psu=ss.length?ss[ss.length-1]:null;}
      var o={};
      if(cs)o.case=cs.id;if(cpu)o.cpu=cpu.id;if(cl)o.cooler=cl.id;if(mb)o.motherboard=mb.id;if(gpu)o.gpu=gpu.id;if(ram)o.ram=ram.id;if(st)o.storage=st.id;if(psu)o.psu=psu.id;
      return o;
    }
    function buildName(){
      if(TIER)return dirty?(TIER+' Custom'):(TIER+' Build');
      var t=null;for(var i=0;i<TIERS.length;i++){if(TIERS[i].id===preset)t=TIERS[i];}var base=t?t.n:'Custom';return dirty?(base+' Custom'):(t?(base+' Build'):'Custom Build');
    }
    function shortName(s){if(!s)return '';var t=String(s),cut=t.length;['|',',','('].forEach(function(ch){var i=t.indexOf(ch);if(i>0&&i<cut)cut=i;});t=t.slice(0,cut).trim();if(t.length>46)t=t.slice(0,44).trim()+'\u2026';return t;}
    function chip(s){if(!s)return '';return shortName(String(s).replace('NVIDIA ','').replace('GeForce ','').replace('AMD ','').replace('Intel Core ','').replace('Intel ',''));}
    function metaLine(k,o){
      if(k==='cpu')return (o.socket||'')+(truthy(o.igpu)?' \u00b7 has graphics':' \u00b7 needs GPU');
      if(k==='motherboard')return (o.socket||'')+' \u00b7 '+(o.form_factor||'')+' \u00b7 '+(o.ram_type||'');
      if(k==='ram')return (o.ram_type||'')+' memory';
      if(k==='gpu'){var s=num(o.power)!=null?o.power+'W':'';if(num(o.length)!=null)s+=(s?' \u00b7 ':'')+o.length+'mm';return s;}
      if(k==='storage')return 'M.2 NVMe SSD';
      if(k==='cooler'){var s=o.cooler_type==='AIO'?'Liquid AIO':'Air cooler';if(num(o.height)!=null)s+=' \u00b7 '+o.height+'mm';return s;}
      if(k==='case'){var s=o.form_factor||'';if(num(o.max_gpu)!=null)s+=(s?' \u00b7 ':'')+'GPU '+o.max_gpu+'mm';return s;}
      if(k==='psu')return (num(o.wattage)!=null?o.wattage+'W':'')+' power supply';
      return '';
    }
    function renderPresets(){
      if(TIER){
        return `<span class='dmpb-tier-badge'>${svg('shield',14)}Building <b>${esc(TIER)}</b></span><a class='dmpb-tier-all' href='${esc(window.location.pathname)}'>See all parts</a>`;
      }
      var h=`<span class='dmpb-presets-lb'>Quick start</span>`;
      for(var i=0;i<TIERS.length;i++){var t=TIERS[i];h+=`<button type='button' class='dmpb-preset${preset===t.id&&!dirty?' on':''}' data-preset='${t.id}'>${esc(t.n)}</button>`;}
      return h;
    }
    function updateImg(){
      var cs=getOpt('case',sel.case);
      if(String(sel.case)!==String(lastImg)){
        $('[data-img]').innerHTML=cs&&cs.image?`<img src='${esc(cs.image)}' alt='${esc(cs.title)}'>`:`<span class='dmpb-noimg'></span>`;
        lastImg=sel.case;
      }
    }
    function renderOv(){
      var cs=getOpt('case',sel.case),gpu=getOpt('gpu',sel.gpu),cpu=getOpt('cpu',sel.cpu);
      var h=`<div class='dmpb-studio-floor'></div><div class='dmpb-chips'>`;
      if(gpu)h+=`<span class='dmpb-chip'>${esc(chip(gpu.title))}</span>`;
      if(cpu)h+=`<span class='dmpb-chip'>${esc(chip(cpu.title))}</span>`;
      h+=`</div>`;
      if(cs&&cs.url)h+=`<a class='dmpb-exp' href='${esc(cs.url)}' target='_blank' rel='noopener' title='View photos'>${svg('expand',15)}</a>`;
      h+=`<div class='dmpb-studio-name'><span class='dmpb-ey'>Your chassis</span><span class='dmpb-studio-nm'>${esc(cs?shortName(cs.title):'Preview')}</span></div>`;
      return h;
    }
    function renderWatt(){
      var psu=getOpt('psu',sel.psu),load=estLoad(),cap=psu?num(psu.wattage)||0:0;
      var pct=cap?Math.min(100,Math.round(load/cap*100)):100;
      var tone=pct>87?'#e0564f':(pct>72?'#e0a14f':'#5eb7e8');
      return `<div class='dmpb-watt'><div class='dmpb-watt-top'><span>Est. power draw</span><span>~${load}W / ${cap}W</span></div><div class='dmpb-watt-bar'><i style='width:${pct}%;background:${tone};box-shadow:0 0 12px ${tone}'></i></div></div>`;
    }
    function renderSummary(){
      var blk=blocked();
      var h=`<aside class='dmpb-sum'>`;
      h+=`<div class='dmpb-sum-price'><div class='dmpb-sum-price-l'><span class='dmpb-ey'>Total</span><b>${money(total())}</b></div><button type='button' class='dmpb-add' data-add${blk?' disabled':''}>${blk?'Resolve issues first':(editId?'Update build':'Add build to cart')}</button></div>`;
      h+=`<button type='button' class='dmpb-sum-head' data-details><span class='dmpb-sum-ico'>${svg(blk?'alert':'shield',17)}</span><span class='dmpb-sum-meta'><span class='dmpb-ey'>${editId?'Editing cart build':(dirty?'Editing your build':'Your build')}</span><span class='dmpb-sum-nm'>${esc(buildName())} \u00b7 ${CATS.length} parts</span></span><span class='dmpb-sum-tog'>${detailsOpen?'Hide':'Details'}${svg('chev',14)}</span></button>`;
      if(detailsOpen){
        h+=`<div class='dmpb-sum-body'>`;
        for(var i=0;i<CATS.length;i++){var c=CATS[i],o=getOpt(c.k,sel[c.k]);h+=`<button type='button' class='dmpb-sum-row' data-jump='${c.k}'><span><span class='dmpb-sum-cat'>${esc(c.n)}</span><span class='dmpb-sum-pn'>${esc(o?o.title:'Not selected')}</span></span><span class='dmpb-sum-pp'>${o?money(o.price):'\u2014'}</span></button>`;}
        h+=renderWatt()+`</div>`;
      }
      if(blk)h+=`<div class='dmpb-sum-err'>${conflicts().length+dimErrCount()} issue(s) to fix above</div>`;
      h+=`</aside>`;
      return h;
    }
    function optRow(k,o,onSel,bad){
      var cur=getOpt(k,sel[k]),base=cur?cur.price:o.price,delta=o.price-base;
      var th=o.image?`<img src='${esc(o.image)}' alt=''>`:`<span class='dmpb-noimg'></span>`;
      var h=`<button type='button' class='dmpb-opt${onSel?' on':''}${bad?' bad':''}' data-pick='${k}' data-id='${esc(String(o.id))}'>`;
      h+=`<span class='dmpb-rad'>${onSel?svg('check',12):''}</span>`;
      h+=`<span class='dmpb-th'>${th}</span>`;
      h+=`<span class='dmpb-main'><span class='dmpb-nm'>${esc(o.title)}`;
      if(o.badge&&!bad)h+=`<span class='dmpb-bdg'>${esc(o.badge)}</span>`;
      if(bad)h+=`<span class='dmpb-badtag'>${esc(badReason(k,o))}</span>`;
      h+=`</span><span class='dmpb-sp'>${esc(metaLine(k,o))}</span></span>`;
      h+=`<span class='dmpb-pr'><span class='dmpb-p'>${money(o.price)}</span>`;
      if(delta!==0)h+=`<span class='dmpb-d${delta>0?'':' neg'}'>${delta>0?'+':''}${money(delta)}</span>`;
      h+=`</span></button>`;
      return h;
    }
    function renderStep(c,idx){
      var sp=split(c.k);
      var cf=conflicts().filter(function(x){return x.keys.indexOf(c.k)>=0;});
      var di=dimIssues().filter(function(x){return x.keys.indexOf(c.k)>=0;});
      var h=`<section class='dmpb-step' data-step='${c.k}'><div class='dmpb-step-h'><span class='dmpb-step-n'>${idx<9?'0':''}${idx+1}</span><span class='dmpb-step-ic'>${svg(c.ic,22)}</span><h3 class='dmpb-step-t'>${esc(c.n)}</h3></div>`;
      for(var a=0;a<cf.length;a++){h+=`<div class='dmpb-flag err'><span class='ic'>${svg('alert',17)}</span><span>${esc(cf[a].msg)}</span></div>`;}
      for(var b=0;b<di.length;b++){h+=`<div class='dmpb-flag ${di[b].level==='error'?'err':'warn'}'><span class='ic'>${svg('alert',17)}</span><span>${esc(di[b].msg)}</span></div>`;}
      h+=`<div class='dmpb-opts'>`;
      for(var i=0;i<sp.ok.length;i++){var o=sp.ok[i];h+=optRow(c.k,o,String(sel[c.k])===String(o.id),false);}
      if(!sp.ok.length)h+=`<div class='dmpb-empty'>Nothing in stock fits the current combination \u2014 change the highlighted part above to open this up.</div>`;
      h+=`</div>`;
      if(sp.bad.length){
        var rv=reveal[c.k];
        h+=`<button type='button' class='dmpb-reveal' data-reveal='${c.k}'>${rv?'Hide':'Show'} ${sp.bad.length} incompatible</button>`;
        if(rv){h+=`<div class='dmpb-opts dmpb-opts-bad'>`;for(var j=0;j<sp.bad.length;j++){var ob=sp.bad[j];h+=optRow(c.k,ob,String(sel[c.k])===String(ob.id),true);}h+=`</div>`;}
      }
      h+=`</section>`;
      return h;
    }
    function renderNav(){
      var iss={};
      conflicts().forEach(function(x){x.keys.forEach(function(kk){iss[kk]='error';});});
      dimIssues().forEach(function(x){x.keys.forEach(function(kk){if(iss[kk]!=='error')iss[kk]=x.level;});});
      var h=`<nav class='dmpb-nav'>`;
      for(var i=0;i<CATS.length;i++){var c=CATS[i];h+=`<button type='button' class='dmpb-pill${active===c.k?' on':''}' data-jump='${c.k}'>${svg(c.ic,15)}<span>${esc(c.n)}</span>${iss[c.k]?`<i class='dmpb-dot ${iss[c.k]==='error'?'err':'warn'}'></i>`:''}</button>`;}
      h+=`</nav>`;
      return h;
    }
    function renderFinish(){
      var blk=blocked();
      return `<div class='dmpb-finish'><div><span class='dmpb-ey'>${blk?'Resolve issues to finish':(editId?'Ready to update':'Build complete')}</span><div class='dmpb-finish-t'><b>${money(total())}</b><span>${CATS.length} parts</span></div></div><button type='button' class='dmpb-add' data-add${blk?' disabled':''}>${blk?'Resolve issues first':(editId?'Update build':'Add build to cart')}</button></div>`;
    }
    function renderBar(){
      var blk=blocked();
      var lbl=blk?'Issues to fix':(TIER?(TIER+' \u00b7 Total'):'Total');
      return `<div class='dmpb-bar-l'><span class='dmpb-ey'>${esc(lbl)}</span><b>${money(total())}</b></div><button type='button' class='dmpb-add' data-add${blk?' disabled':''}>${blk?'Fix issues':(editId?'Update build':'Add to cart')}</button>`;
    }
    function render(){
      $('[data-presets]').innerHTML=renderPresets();
      updateImg();
      $('[data-ov]').innerHTML=renderOv();
      $('[data-summary]').innerHTML=renderSummary();
      var steps='';for(var i=0;i<CATS.length;i++){steps+=renderStep(CATS[i],i);}
      $('[data-right]').innerHTML=renderNav()+`<div class='dmpb-steps-list'>`+steps+`</div>`+renderFinish();
      $('[data-bar]').innerHTML=renderBar();
    }
    function cascadeFromCpu(cpuObj){
      var mb=getOpt('motherboard',sel.motherboard);
      if(!mb||mb.socket!==cpuObj.socket){
        var newMb=cheapestWhere(list('motherboard'),function(m){return m.socket===cpuObj.socket;},allList('motherboard'));
        if(newMb)sel.motherboard=newMb.id;
      }
      cascadeFromMb();
    }
    function cascadeFromMb(){
      var mb=getOpt('motherboard',sel.motherboard);
      if(!mb)return;
      var ram=getOpt('ram',sel.ram);
      if(!ram||ram.ram_type!==mb.ram_type){
        var newRam=cheapestWhere(list('ram'),function(r){return r.ram_type===mb.ram_type;},allList('ram'));
        if(newRam)sel.ram=newRam.id;
      }
      var cs=getOpt('case',sel.case);
      if(cs&&!caseAccepts(cs,mb.form_factor)){
        var newCase=cheapestWhere(list('case'),function(c){return caseAccepts(c,mb.form_factor);},allList('case'));
        if(newCase)sel.case=newCase.id;
      }
    }
    function setOpt(k,id){
      var _sy=window.scrollY;
      sel[k]=id;anchor=k;dirty=true;reveal={};
      if(k==='cpu'){var cpuObj=getOpt('cpu',id);if(cpuObj)cascadeFromCpu(cpuObj);}
      if(k==='motherboard'){cascadeFromMb();}
      render();
      window.scrollTo(0,_sy);
    }
    function applyPreset(id){var t=null;for(var i=0;i<TIERS.length;i++){if(TIERS[i].id===id)t=TIERS[i];}if(!t)return;sel=computePreset(t.frac);anchor=null;preset=id;dirty=false;reveal={};editId=null;editKeys=null;lastImg='__force__';render();var y=root.getBoundingClientRect().top+window.pageYOffset-16;window.scrollTo({top:y<0?0:y,behavior:'smooth'});}
    function jump(k){var el=root.querySelector(`[data-step='${k}']`);if(el){var y=el.getBoundingClientRect().top+window.pageYOffset-130;window.scrollTo({top:y,behavior:'smooth'});}}
    root.addEventListener('click',function(e){
      var t=e.target,c;
      c=t.closest('[data-pick]');if(c){setOpt(c.getAttribute('data-pick'),c.getAttribute('data-id'));return;}
      c=t.closest('[data-reveal]');if(c){var rk=c.getAttribute('data-reveal');var _sy1=window.scrollY;reveal[rk]=!reveal[rk];render();window.scrollTo(0,_sy1);return;}
      c=t.closest('[data-details]');if(c){var _sy2=window.scrollY;detailsOpen=!detailsOpen;render();window.scrollTo(0,_sy2);return;}
      c=t.closest('[data-preset]');if(c){applyPreset(c.getAttribute('data-preset'));return;}
      c=t.closest('[data-jump]');if(c){jump(c.getAttribute('data-jump'));return;}
      c=t.closest('[data-add]');if(c){if(!blocked())submit();return;}
    });
    function submit(){
      var bid='b'+Date.now(),bn=buildName(),items=[];
      for(var i=0;i<CATS.length;i++){var p=getOpt(CATS[i].k,sel[CATS[i].k]);if(p)items.push({id:p.id,quantity:1,properties:{_build_id:bid,Build:bn,Component:CATS[i].n}});}
      if(!items.length)return;
      var btns=root.querySelectorAll('[data-add]');for(var b=0;b<btns.length;b++){btns[b].disabled=true;btns[b].textContent=editId?'Updating\u2026':'Adding\u2026';}
      function add(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});}
      var pre=Promise.resolve();
      if(editId&&editKeys&&editKeys.length){var updates={};for(var k=0;k<editKeys.length;k++){updates[editKeys[k]]=0;}pre=fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})});}
      pre.then(add).then(function(r){return r.json();}).then(function(){window.location.href='/cart';}).catch(function(){render();window.alert('Something went wrong updating the cart. Please try again.');});
    }
    function getParam(n){try{return new URLSearchParams(window.location.search).get(n);}catch(e){return null;}}
    function findCat(vid){for(var i=0;i<CATS.length;i++){var a=allList(CATS[i].k);for(var j=0;j<a.length;j++){if(String(a[j].id)===String(vid))return CATS[i].k;}}return null;}
    function loadEdit(id){
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
        var keys=[],found=false,i;
        for(i=0;i<cart.items.length;i++){var it=cart.items[i];if(it.properties&&it.properties._build_id===id){keys.push(it.key);var vid=it.variant_id||it.id;var cat=findCat(vid);if(cat){sel[cat]=vid;found=true;}}}
        if(!found)return;
        editId=id;editKeys=keys;dirty=true;preset=null;anchor=null;reveal={};lastImg='__force__';render();
        var y=root.getBoundingClientRect().top+window.pageYOffset-16;window.scrollTo({top:y<0?0:y,behavior:'auto'});
      }).catch(function(){});
    }
    function onScroll(){
      var cur=CATS[0].k;
      for(var i=0;i<CATS.length;i++){var el=root.querySelector(`[data-step='${CATS[i].k}']`);if(el&&el.getBoundingClientRect().top-130<=0)cur=CATS[i].k;}
      if(cur!==active){active=cur;var pills=root.querySelectorAll('.dmpb-pill');for(var p=0;p<pills.length;p++){pills[p].classList.toggle('on',pills[p].getAttribute('data-jump')===cur);}}
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    var tp=(getParam('tier')||'').toLowerCase();
    if(TIER_SLUGS[tp]){
      TIER=TIER_SLUGS[tp];
      var _h1=root.querySelector('.dmpb-h1');
      if(_h1)_h1.textContent=TIER.toUpperCase()+' \u2014 Build Your PC';
      var _ey=root.querySelector('.dmpb-ey');
      if(_ey)_ey.textContent='The Forge \u00b7 '+TIER+' Tier';
    }
    sel=computePreset(0);preset=TIER?null:'apprentice';dirty=false;render();
    var ed=getParam('edit');if(ed)loadEdit(ed);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
